(function () {
  function initImageCarousel(el) {
    var sectionId = el.id.replace('image-carousel-swiper-', '');
    var cfg = (window.icSectionSettings && window.icSectionSettings[sectionId]) || {};

    if (el.dataset.icInitialized) return;
    el.dataset.icInitialized = 'true';

    var paginationEl = el.querySelector('.image-carousel__pagination');
    var options = {
      slidesPerView: cfg.slidesPerViewMobile || 1.15,
      spaceBetween: cfg.spaceBetween || 12,
      centeredSlides: true,
      loop: !!cfg.loop,
      followFinger: true,
      watchOverflow: true,
      a11y: {
        enabled: true,
        prevSlideMessage: (cfg.labels && cfg.labels.prev) || 'Previous slide',
        nextSlideMessage: (cfg.labels && cfg.labels.next) || 'Next slide',
        slideLabelMessage: (cfg.labels && cfg.labels.slideStatus) || 'Slide {{index}} of {{slidesCount}}'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      autoplay: cfg.autoplay
        ? { delay: cfg.autoplayDelay || 5000, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      breakpoints: {
        990: {
          slidesPerView: cfg.slidesPerViewDesktop || 2.4,
          spaceBetween: (cfg.spaceBetween || 12) * 1.5,
          centeredSlides: true
        }
      }
    };

    if (cfg.showPagination && paginationEl) {
      options.pagination = {
        el: paginationEl,
        type: 'progressbar'
      };
    }

    if (cfg.showArrows) {
      options.navigation = {
        prevEl: cfg.prevEl,
        nextEl: cfg.nextEl
      };
    }

    new Swiper(el, options);
  }

  function initAll() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.image-carousel__slider').forEach(initImageCarousel);
  }

  window.icInitAll = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.image-carousel__slider');
    if (el) {
      el.dataset.icInitialized = '';
      initImageCarousel(el);
    }
  });
})();